module.exports = __webpack_public_path__ + "img/dashboard.0f490bce.svg";